import * as types from 'template/actions/types'
import {apiAction} from 'apa/actions'

const ENDPOINT_TEMPLATE_URL = '/api/template/'
const ENDPOINT_TEMPLATE_CATEGORY_URL = '/api/template/categories/'

export const loadTemplateCategoryList = () => dispatch => {
    dispatch({type: types.LOAD_TEMPLATE_CATEGORIES})
    dispatch(apiAction({
        url: ENDPOINT_TEMPLATE_CATEGORY_URL,
        onSuccess: templateCategoryList => ({
            type: types.LOAD_TEMPLATE_CATEGORIES_SUCCESS,
            templateCategoryList: templateCategoryList
        }),
        onFailure: errors => ({
            type: types.LOAD_TEMPLATE_CATEGORIES_ERROR,
            errors: errors
        })
    }))
}


export const setSearchText = (searchText) => dispatch => {
    dispatch({
        type: types.SET_SEARCH_TEXT,
        searchText: searchText
    })
}

export const selectTemplateCategory = (templateManualCategory) => (dispatch, getState) => {
    const currentSelectedManualCategory = getState().template.selectedCategory
    if (currentSelectedManualCategory && currentSelectedManualCategory.id === templateManualCategory.id) {
        dispatch({
            type: types.SELECT_TEMPLATE_CATEGORY,
            selectedTemplateCategory: null
        })
    } else {
        dispatch({
            type: types.SELECT_TEMPLATE_CATEGORY,
            selectedTemplateCategory: templateManualCategory
        })
        dispatch(loadTemplateList(templateManualCategory))
    }
}

export const deselectTemplateCategory = () => dispatch =>
    dispatch({
        type: types.DESELECT_TEMPLATE_CATEGORY
    })

export const createTemplateCategory = (newTemplateCategory) => dispatch => {
    dispatch({type: types.CREATE_TEMPLATE_CATEGORY})
    dispatch(apiAction({
        url: ENDPOINT_TEMPLATE_CATEGORY_URL,
        method: 'POST',
        data: newTemplateCategory,
        onSuccess: newTemplateCategory => {
            dispatch(loadTemplateCategoryList())
            dispatch(selectTemplateCategory(newTemplateCategory))
            return {
                type: types.CREATE_TEMPLATE_CATEGORY_SUCCESS
            }
        },
        onFailure: errors => ({
            type: types.CREATE_TEMPLATE_CATEGORY_ERROR,
            errors: errors
        })
    }))
}

export const updateTemplateCategory = (category) => dispatch =>
    dispatch({type: types.UPDATE_TEMPLATE_CATEGORY, category: category})


export const saveTemplateCategory = (category) => dispatch => {
    dispatch({type: types.UPDATE_TEMPLATE_CATEGORY})
    dispatch(apiAction({
        url: `${ENDPOINT_TEMPLATE_CATEGORY_URL}${category.id}/`,
        method: 'PATCH',
        data: category,
        onSuccess: category => {
            dispatch(loadTemplateCategoryList())
            dispatch(selectTemplateCategory(category))
            return {
                type: types.UPDATE_TEMPLATE_CATEGORY_SUCCESS
            }

        },
        onFailure: errors => ({
            type: types.UPDATE_TEMPLATE_CATEGORY_ERROR,
            errors: errors
        })
    }))
}

export const deleteTemplateCategory = (category) => dispatch => {
    dispatch({type: types.DELETE_TEMPLATE_CATEGORY})
    dispatch(apiAction({
        url: `${ENDPOINT_TEMPLATE_CATEGORY_URL}${category.id}/`,
        method: 'DELETE',
        onSuccess: () => {
            dispatch(loadTemplateCategoryList())
            return {
                type: types.DELETE_TEMPLATE_CATEGORY_SUCCESS
            }
        },
        onFailure: errors => ({
            type: types.DELETE_TEMPLATE_CATEGORY_ERROR,
            errors: errors
        })
    }))
}

export const loadTemplateList = (templateCategory) => dispatch => {
    dispatch({type: types.LOAD_TEMPLATE_LIST})
    dispatch(apiAction({
        url: `${ENDPOINT_TEMPLATE_CATEGORY_URL}${templateCategory.id}/manuals/`,
        onSuccess: templateList => ({
            type: types.LOAD_TEMPLATE_LIST_SUCCESS,
            templateList: templateList
        }),
        onFailure: errors => ({
            type: types.LOAD_TEMPLATE_LIST_ERROR,
            errors: errors
        })
    }))
}

export const searchTemplate = (searchText) => dispatch => {
    if (searchText === '') {
        dispatch({type: types.SEARCH_TEMPLATE_LIST_RESET})
    } else {
        dispatch({type: types.SEARCH_TEMPLATE_LIST})
        dispatch(deselectTemplate())
        dispatch(deselectTemplateCategory())
        dispatch(apiAction({
            url: `${ENDPOINT_TEMPLATE_URL}?search=${searchText}`,
            onSuccess: templateList => ({
                type: types.SEARCH_TEMPLATE_LIST_SUCCESS,
                templateList: templateList
            }),
            onFailure: errors => ({
                type: types.SEARCH_TEMPLATE_LIST_ERROR,
                errors: errors
            })
        }))
    }
}

export const selectTemplate = (manual) => dispatch =>
    dispatch({type: types.SELECT_TEMPLATE, manual: manual})

export const deselectTemplate = () => dispatch =>
    dispatch({type: types.DESELECT_TEMPLATE})

export const createTemplate = (data) => (dispatch, getState) => {
    dispatch({type: types.CREATE_TEMPLATE})
    dispatch(apiAction({
        url: ENDPOINT_TEMPLATE_URL,
        method: 'POST',
        data: data,
        onSuccess: (template) => {
            dispatch(loadTemplateList(getState().template.selectedTemplateCategory))
            dispatch(selectTemplate(template))
            return {
                type: types.CREATE_TEMPLATE_SUCCESS,
                template: template
            }
        },
        onFailure: errors => ({
            type: types.CREATE_TEMPLATE_ERROR,
            errors: errors
        })
    }))
}

export const updateTemplate = (template) => dispatch =>
    dispatch({type: types.UPDATE_TEMPLATE, template: template})

export const uploadTemplateFile = (templateId, data, onSuccess = () => {
}, onError = () => {
}) => dispatch => {
    dispatch({type: types.UPLOAD_TEMPLATE_FILE})
    dispatch(apiAction({
        url: `${ENDPOINT_TEMPLATE_URL}${templateId}/`,
        method: 'PATCH',
        data: data,
        onSuccess: template => {
            dispatch(selectTemplate(template))
            onSuccess()
            return {
                type: types.UPLOAD_TEMPLATE_FILE_SUCCESS
            }
        },
        onFailure: errors => {
            onError()
            return {
                type: types.UPLOAD_TEMPLATE_FILE_ERROR,
                errors: errors
            }
        }
    }))
}

export const saveTemplate = (template) => (dispatch, getState) => {
    const newTemplate = {...template}
    delete newTemplate.template_file
    delete newTemplate.category
    delete newTemplate.file_exists
    dispatch(apiAction({
        url: `${ENDPOINT_TEMPLATE_URL}${newTemplate.id}/`,
        method: 'PATCH',
        data: newTemplate,
        onSuccess: newManual => {
            const newManualList = getState().template.templateList.map(
                obj => obj.id == newManual.id ? newManual : obj
            )
            return {
                type: types.SAVE_TEMPLATE_SUCCESS,
                templateList: newManualList
            }
        },
        onFailure: errors => ({
            type: types.SAVE_TEMPLATE_ERROR,
            errors: errors
        })
    }))
}

export const deleteTemplate = template => (dispatch, getState) => {
    dispatch({type: types.DELETE_TEMPLATE})
    const state = getState()
    dispatch(apiAction({
            url: `${ENDPOINT_TEMPLATE_URL}${template.id}/`,
            method: 'DELETE',
            onSuccess: () => {
                dispatch(loadTemplateList(state.template.selectedTemplateCategory))
                return {
                    type: types.DELETE_TEMPLATE_SUCCESS
                }
            },
            onFailure: errors => ({
                type: types.DELETE_TEMPLATE_ERROR,
                errors: errors
            })
        })
    )
}
